import React, {useLayoutEffect} from 'react';
import {Logo} from '../Logo/Logo';
import {ChannelStoryIcon} from './icons/ChannelStoryIcon';
import {ChannelMobileIcon} from './icons/ChannelMobileIcon';
import {ChannelDesktopIcon} from './icons/ChannelDesktopIcon';
import {ChannelKitIcon} from './icons/ChannelKitIcon';
import ChannelButton from './components/ChannelButton/ChannelButton';
import {LogoSberMainPage} from '../Logo/LogoSberMainPage';
import {Helmet} from 'react-helmet';
import {LogoThemeWhite} from "../Logo/LogoThemeWhite";
import './styles/startPage.scss';

const imageUrl = `${process.env.PUBLIC_URL}/images/start-page-background.jpg`;
const videoUrl = `${process.env.PUBLIC_URL}/resources/video/start-page-background.mp4`;

const StartPage: React.FC = () => {
    useLayoutEffect(() => {
        document.body.classList.add('start-page-body');

        // В Yandex браузере видео имеет другой цвет. Фикс фона документа под этот цвет.
        const ua = navigator.userAgent;
        if (ua.search(/YaBrowser/) > 0) {
            const body = document.querySelector('body');
            if (body) {
                body.style.backgroundColor = '#D4D5D7';
            }
        }

        return () => document.body.classList.remove('start-page-body');
    }, []);

    return (
        <div className="start-page">

            <Helmet>
                <meta property="og:url" content={document.location.href} />
                <meta property="og:type"               content="website" />
            </Helmet>

            <video autoPlay loop muted playsInline poster={imageUrl}>
                <source src={videoUrl} type="video/mp4" onLoadedData={() => {}} />
            </video>

            <div className="gradient left" />
            {/*<div className="gradient right" />*/}

            <header className="start-page-header">
                <Logo logoIcon={<LogoThemeWhite className="logo-icon-start-page" />} />
                <LogoSberMainPage className="logo-sber" />
            </header>

            <main>
                <h1>Медиагайд</h1>
                <p>
                    Материалы и инструкции<br />
                    СберБизнес для работы<br />
                    с медиаформатами
                </p>
                <div className="button-group">
                    <ChannelButton pathname="/SberBusiness/Медиакит/sberbusiness" icon={<ChannelStoryIcon className="channel-icon" />} label="СберБизнес" />
                    <ChannelButton pathname="/SberAPI/Медиакит/sber%20api" icon={<ChannelKitIcon className="channel-icon" />} label="Сбер API" />
                </div>
            </main>

            <footer>
                © 1997—{new Date().getFullYear()} ПАО Сбербанк.
                <br />
                Генеральная лицензия на осуществление банковских операций
                <br />
                от 11 августа 2015 года. Регистрационный номер — 1481.
            </footer>
        </div>
    );
}

export default StartPage;
